import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { ArrowLeft, Lock, Eye, EyeSlash } from 'react-bootstrap-icons';
import "../../../assets/css/Drivers/DriverAuth/DriverResetPassword.css";
import resetpassword from "../../../assets/images/resetpassword .png";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverResetPassword = () => {
  const { baseUrl, RegExpChecker } = useContext(AppContext);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  // form validation check
  const isFormValid =
    password &&
    confirmPassword &&
    !errors.password &&
    !errors.confirmPassword;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("user_type", "driver");
    formData.append("new_password", password);

    axios
      .post(`${baseUrl}/general/forgotpassword/resetPassword`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          alert("Password reset successfully. Please login.");
          navigate('/driver-login');
        } else {
          alert(response.data.message || "Something went wrong");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <div className="driver-reset-password">
      <Container>
        <Row>
          <Col xs={12}>
            <Button
              variant="link"
              className="driver-reset-password__back-btn"
              onClick={() => navigate('/driver-otp-verification')}
            >
              <ArrowLeft size={24} />
            </Button>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="driver-reset-password__image-section">
              <div className="driver-reset-password__image-placeholder">
                <img
                  src={resetpassword}
                  alt="Reset Password"
                  className="driver-reset-password__image"
                />
              </div>
            </div>

            <div className="driver-reset-password__heading-section">
              <h2 className="driver-reset-password__title">
                Reset Your Password
              </h2>
              <p className="driver-reset-password__subtitle">
                Create a secure and memorable new password.
              </p>
            </div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="driver-reset-password__form-group">
                <Form.Label className="driver-reset-password__label">
                  Password
                </Form.Label>
                <div className="driver-reset-password__input-wrapper">
                  <Lock className="driver-reset-password__input-icon" size={20} />
                  <Form.Control
                    type={showPassword1 ? 'text' : 'password'}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPassword(value);

                      const regError = RegExpChecker("password", value);

                      setErrors((prev) => ({
                        ...prev,
                        password: value && regError ? regError : "",
                        confirmPassword:
                          confirmPassword && value !== confirmPassword
                            ? "Passwords do not match"
                            : "",
                      }));
                    }}
                    className="driver-reset-password__input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword1(!showPassword1)}
                    className="driver-reset-password__toggle-btn"
                  >
                    {showPassword1 ? <EyeSlash size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {errors.password && (
                  <small className="text-danger">{errors.password}</small>
                )}
              </Form.Group>

              <Form.Group className="driver-reset-password__form-group">
                <Form.Label className="driver-reset-password__label">
                  Confirm Password
                </Form.Label>
                <div className="driver-reset-password__input-wrapper">
                  <Lock className="driver-reset-password__input-icon" size={20} />
                  <Form.Control
                    type={showPassword2 ? 'text' : 'password'}
                    placeholder="Enter password"
                    value={confirmPassword}
                    onChange={(e) => {
                      const value = e.target.value;
                      setConfirmPassword(value);

                      setErrors((prev) => ({
                        ...prev,
                        confirmPassword:
                          value && value !== password
                            ? "Passwords do not match"
                            : "",
                      }));
                    }}
                    className="driver-reset-password__input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword2(!showPassword2)}
                    className="driver-reset-password__toggle-btn"
                  >
                    {showPassword2 ? <EyeSlash size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                {errors.confirmPassword && (
                  <small className="text-danger">{errors.confirmPassword}</small>
                )}
              </Form.Group>

              <Button
                type="submit"
                className="driver-reset-password__submit-btn w-100"
                disabled={loading || !isFormValid}
              >
                {loading ? "Resetting..." : "Send"}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DriverResetPassword;